import {
  enhancedMakeFetchAction,
  generateEndpoint
} from '@stagapps/redux-utils'
import { API_BASE_URL } from 'config/env.config'

const GET_EMPLOYEE_PROGRAM_ORDERS_API =
  'EMPLOYEE/GET_EMPLOYEE_PROGRAM_ORDERS_API'

const apiCall = enhancedMakeFetchAction(
  GET_EMPLOYEE_PROGRAM_ORDERS_API,
  ({ id, programId, ...params }) => ({
    endpoint: generateEndpoint({
      host: `${API_BASE_URL}/investcore-api/flex/employee/v1/employees/${id}/employee-programs/${programId}/program-orders`,
      params
    }),
    method: 'GET'
  })
)

export default apiCall
